import {Component, Input, ElementRef, ViewChild, AfterViewInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WebpUrlPipe} from '../../pipes/webp-url/webp-url.pipe';
import {decode} from 'blurhash';

@Component({
  selector: 'app-webp-image',
  standalone: true,
  imports: [CommonModule, WebpUrlPipe],
  templateUrl: './webp-image.component.html',
  styleUrls: ['./webp-image.component.css']
})
export class WebpImageComponent implements AfterViewInit {
  @Input() src!: string;
  @Input() alt: string = '';
  @Input() title: string = '';
  @Input() imgClass: string = '';
  @Input() imgStyle: any = null;
  @Input() blurhash: string | null = null;
  @Input() blurWidth: number = 32;
  @Input() blurHeight: number = 32;

  @ViewChild('canvas', {static: false}) canvasRef?: ElementRef<HTMLCanvasElement>;

  public imageLoaded: boolean = false;

  ngAfterViewInit(): void {
    if (this.blurhash && this.canvasRef) {
      this.renderBlurHash();
    }
  }

  public onImageLoad(): void {
    this.imageLoaded = true;
  }

  private renderBlurHash(): void {
    if (!this.blurhash || !this.canvasRef) {
      return;
    }

    try {
      const pixels = decode(this.blurhash, this.blurWidth, this.blurHeight);
      const canvas = this.canvasRef.nativeElement;
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        return;
      }

      canvas.width = this.blurWidth;
      canvas.height = this.blurHeight;

      const imageData = ctx.createImageData(this.blurWidth, this.blurHeight);
      imageData.data.set(pixels);
      ctx.putImageData(imageData, 0, 0);
    } catch (error) {
      console.error('Failed to decode BlurHash:', error);
    }
  }
}
